import _ from "underscore";
import {CellItem} from './cellItem'
import {XmlTagInfo} from '../xmlTagProvider'
import {ValidateResult} from '../contentType'
import {ComboItem} from './combo'

export class InputTextItem extends CellItem {

	targetIds: string[] = [];
	text: string;
    required: boolean;

	static fromXml(config: XmlTagInfo){
		return new InputTextItem(config);
	}

	private constructor(config: XmlTagInfo) {
		super(config);
		this.targetIds = config.children
			.filter( (c: XmlTagInfo) => c.tag === 'target')
			.map( (c: XmlTagInfo) => c.attributes['id']);

		this.text = config.attributes['text'];
        this.required = config.attributes['validate'] !== 'no';
	}

	getView() {
		return null;
	}

	isVisible(){
		if(this.targetIds.length === 0){
			var combo = this.findCombo();
			if(combo){
				var selected = combo.getSelectedOption();
				if(selected && selected.hasInputText){
					this.text = selected.inputTextText!; // It is ok, it is checked
					return true;
				}
				return false;
			}
			return this.cell.active;
		}
        // self.form.grid is set in init()
		return _.reduce(this.targetIds, (result:boolean, id:string) => result || this.form!.grid.cellById[id].active, false);
	}

	set(value: any){
		this.setVariable(value);
        this.updateUnknowns();
		this.form.reValidate();
	}

	validate(){
		if (!this.isVisible()) {
			return ValidateResult.okResult();
		}
        if (!this.required) {
           return ValidateResult.okResult();
        }
		const value = this.getVariable();
		if( !this.textValueFilled(value)) {
			return ValidateResult.errorResult();
		}

		// this.contentType is set in init()
        return this.contentType!.validate(value);

	}

	onNext(){
		if(!this.isVisible()){
			this.reset();
		}
	}

	private findCombo(){
		return <ComboItem>this.cell.getItems().filter(i => i instanceof ComboItem)[0];
	}
}